import React, { useEffect, useState } from 'react'
import SelectField from '../../../../FormControl/input/SelectField'
import { Skeleton, Typography } from '@mui/material';
import { getCurriculum } from '../../../../../services/curriculum/curriculum.service'

const SelectCurriculum = ({ id, onChange, onClear, name, value, error, disabled, isPreview }) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorFetch, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await getCurriculum()
        if (!response?.data && response?.error) {
          setError(response.error.message || 'An error ocurred');
        } else {
          setData(response?.data || null);
        }
      } catch (error) {
        const message = handlerErrorV2(error);
        setError(message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  if (isPreview) {
    return (
      <Typography>
        { isLoading ? <Skeleton /> : data?.find(item => item._id === value)?.name}
      </Typography>
    )
  }
  return (
    <SelectField
      id={id}
      error={errorFetch || error}
      helperText={errorFetch || error}                    
      value={value}
      name={name}
      onChange={onChange}      
      options={data?.map(item => ({ value: item._id, label: item.name })) || []}
      placeholder="Choose a curriculum"
      loading={isLoading}
      disabled={isLoading || disabled}
      onClear={onClear}
    />  
  )
}

export default SelectCurriculum
